import { FilePdfOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React, { useCallback } from "react";
import { DOWNLOAD_CMR } from "../../../../constants/events";
import ee from "../../../../services/EventEmitter";
import { CAN_DOWNLOAD_CMR } from "../../../../constants/authorize";
import Authorize from "../../../Authorize";

interface Props {
  id: number;
}

const Pdf: React.FC<Props> = ({ id }) => {
  const onClickHandler = useCallback(() => {
    ee.emit(DOWNLOAD_CMR, {
      id,
    });
  }, [id]);

  return (
    <Authorize permission={CAN_DOWNLOAD_CMR}>
      <Button type="primary" onClick={onClickHandler}>
        <FilePdfOutlined />
      </Button>
    </Authorize>
  );
};

export default Pdf;
